// Wrapper around store, can be used on client and server

import { TDict } from '../../../shared/types/utilityTypes';

type TSharedState<SiteMetaType, SiteConfigType> = {
  auth: any;
  isLoggedIn: boolean;
  currentFeatures: TDict<boolean>;
  consentManagementEnabled: boolean;
  siteMeta: SiteMetaType;
  siteConfig: SiteConfigType;
};

let currentStore: any = null;

export interface IFrontendStore {
  init(store: any): void;
  getState<SiteMetaType, SiteConfigType>(): TSharedState<SiteMetaType, SiteConfigType>;
  getStore(): any;
}

const frontendStore: IFrontendStore = {
  init(store: any) {
    currentStore = store;
  },

  getState() {
    if (!currentStore) {
      throw new Error('failed to find currentStore');
    }
    return currentStore.getState();
  },

  /**
   * Returns the Redux store instance.
   * Use this for immediate reducer/saga injection at module load time.
   */
  getStore() {
    return currentStore;
  }
};

export default frontendStore;
